/**
 * @generated SignedSource<<9174fb785bcc9db91ec25a02d593d380>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgentConnectedDialogRendererQuery$variables = {
  slug: string;
};
export type AgentConnectedDialogRendererQuery$data = {
  readonly organization: {
    readonly " $fragmentSpreads": FragmentRefs<"AgentConnectedDialog_organization">;
  } | null;
};
export type AgentConnectedDialogRendererQuery = {
  response: AgentConnectedDialogRendererQuery$data;
  variables: AgentConnectedDialogRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentConnectedDialogRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AgentConnectedDialog_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentConnectedDialogRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b2b58a6ddbd4e70343e2d46364d5cf27",
    "id": null,
    "metadata": {},
    "name": "AgentConnectedDialogRendererQuery",
    "operationKind": "query",
    "text": "query AgentConnectedDialogRendererQuery(\n  $slug: ID!\n) {\n  organization(slug: $slug) {\n    ...AgentConnectedDialog_organization\n    id\n  }\n}\n\nfragment AgentConnectedDialog_organization on Organization {\n  slug\n}\n"
  }
};
})();

(node as any).hash = "32b4bd709aa38010dc02139b79a37667";

export default node;
